import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.FETCH_VIOLATE_POLICY_ORDERS.REQUEST, saga.fetchViolatePolicyOrders);
    yield takeLatest(constants.UPDATE_REASON.REQUEST, saga.updateReason);
    yield takeLatest(constants.UPDATE_REASON.FAILED, saga.resultUpdate);
}